module.exports = __webpack_public_path__ + "img/asset_USDC.304e5afc.svg";